/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Dry_Crab_FlowInputs */

const en_flat_dry_crab_flow = /** @type {(inputs: Flat_Dry_Crab_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Access`)
};

const de_flat_dry_crab_flow = /** @type {(inputs: Flat_Dry_Crab_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Freigabe`)
};

/**
* | output |
* | --- |
* | "General Access" |
*
* @param {Flat_Dry_Crab_FlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_dry_crab_flow = /** @type {((inputs?: Flat_Dry_Crab_FlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Dry_Crab_FlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_dry_crab_flow(inputs)
	return de_flat_dry_crab_flow(inputs)
});